import { useTranslations } from 'next-intl';

import { StatusBanner } from '@/components/ui/status-banner';
import { useTradingRestricted } from '@/hooks/trading/use-trading-restricted';

/**
 * Inline explanation shown next to a control disabled for a trading-restricted account.
 * Renders nothing unless the account is restricted (and `applies`), so callers can mount it
 * unconditionally instead of adding another branch to already busy components.
 */
export function TradingRestrictedNotice({
  className,
  applies = true,
}: {
  readonly className?: string;
  /** False when the surrounding action is not one the restriction blocks (e.g. a sell). */
  readonly applies?: boolean;
}): React.ReactNode {
  const t = useTranslations('trade');
  const restricted = useTradingRestricted();
  if (!applies || !restricted) return null;
  return (
    <StatusBanner
      tone="info"
      description={t('trading_restricted')}
      {...(className ? { className } : {})}
    />
  );
}
